import * as log from '@/model/util/log/Logger'

/**
 * アドレスバーを除外した高さをcss変数に設定する
 * cssではアドレスバーを含んでしまうので現時点ではjavascriptで計算をする。
 */
const setHeightVh = () => {
  // アドレスバーを除く高さを--vh変数に設定する
  const vh = window.innerHeight * 0.01
  const value = `${vh}px`
  log.debug(`vh calc. value:${value}`)
  document.documentElement.style.setProperty('--vh', value)
}

export { setHeightVh }
